import { WagmiConfig } from "@/types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../reducer";

export interface IInfoWagmiConfig {
  identity: WagmiConfig;
  affiliateManager: WagmiConfig;
  freeGasManager: WagmiConfig;
  fiat: WagmiConfig;
  singleAssetBase: WagmiConfig;
  pancakeRouter: WagmiConfig;
  pancakeFactory: WagmiConfig;
  collectionAssetBase: WagmiConfig;
  projectProfile: WagmiConfig;
  collectionAssetExchange: WagmiConfig;
  singlePoolRouter: WagmiConfig;
  singlePoolFactory: WagmiConfig;
  topupManager: WagmiConfig;
  hyperPoolRouter: WagmiConfig;
  hyperAssetBase: WagmiConfig;
  vaultManager: WagmiConfig;
  verifyDocumentManager: WagmiConfig;
}

export interface ContractState {
  myAddress: string;
  infoWagmiConfig: IInfoWagmiConfig;
  loadedInfoContracts: boolean;
  loadingBalance: boolean;
  balance: number;
  decimals: number;
}

export const initialState: ContractState = {
  myAddress: null,
  infoWagmiConfig: {
    identity: new WagmiConfig(),
    affiliateManager: new WagmiConfig(),
    freeGasManager: new WagmiConfig(),
    fiat: new WagmiConfig(),
    singleAssetBase: new WagmiConfig(),
    pancakeRouter: new WagmiConfig(),
    pancakeFactory: new WagmiConfig(),
    collectionAssetBase: new WagmiConfig(),
    projectProfile: new WagmiConfig(),
    collectionAssetExchange: new WagmiConfig(),
    singlePoolRouter: new WagmiConfig(),
    singlePoolFactory: new WagmiConfig(),
    topupManager: new WagmiConfig(),
    hyperPoolRouter: new WagmiConfig(),
    hyperAssetBase: new WagmiConfig(),
    vaultManager: new WagmiConfig(),
    verifyDocumentManager: new WagmiConfig(),
  },
  loadedInfoContracts: false,
  loadingBalance: false,
  balance: 0,
  decimals: 0,
};

export const contractSlice = createSlice({
  name: "contract",
  initialState,
  reducers: {
    getInforWagmiConfigSuccess: (
      state,
      { payload }: PayloadAction<IInfoWagmiConfig>
    ) => {
      const keys = Object.keys(payload);
      keys?.forEach((key) => {
        if (!!payload[key]) {
          state.infoWagmiConfig[key] = {
            abi: JSON.parse(payload[key]?.abiFileContent),
            address: payload[key]?.address,
          };
        } else {
          state.infoWagmiConfig[key] = { abi: "", address: "" };
        }
      });
      state.loadedInfoContracts = true;
    },

    getInfoContractsFail: (state) => {
      state.loadedInfoContracts = false;
    },
  },
});

export const sliceActions = contractSlice.actions;
export const contractReducer = contractSlice.reducer;
export const contractSelector = (state: RootState) => state.contract;
